import { render, staticRenderFns } from "./ItemEditorTestPanel.vue?vue&type=template&id=5d719770&"
import script from "./ItemEditorTestPanel.vue?vue&type=script&lang=ts&"
export * from "./ItemEditorTestPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports